import {
  type ColumnFiltersState,
  type PaginationState,
  type SortingState,
  type Table,
} from '@tanstack/react-table';
import { useEffect } from 'react';

interface UseResetDataTableRowSelectionOnStateChangeOptions<TData> {
  table: Table<TData>;
  pagination?: PaginationState;
  sorting?: SortingState;
  columnFilters?: ColumnFiltersState;
}

/**
 * Resets row selection whenever table state changes that affect displayed data.
 * This ensures that selections don't persist when the underlying data changes
 * due to pagination, sorting, or filtering.
 */
export function useResetDataTableRowSelectionOnStateChange<TData>({
  table,
  pagination,
  sorting,
  columnFilters,
}: UseResetDataTableRowSelectionOnStateChangeOptions<TData>) {
  useEffect(() => {
    table.resetRowSelection();
  }, [
    pagination?.pageIndex,
    pagination?.pageSize,
    sorting,
    columnFilters,
    table,
  ]);
}
